<template>
  <div class="main-class">
    <div class="ma-3">
      <v-card class="py-2">
        <v-card-title>
          <div class="card-title-class pa-3">
            <div class="title-card-text-class text-start">
              <div>
                <v-btn color="primary" text @click="positionDialog = true">
                  {{ this.params.positionName }}
                </v-btn>
                <div>工资待遇</div>
              </div>
              <div class="text-body-2">
                <span>
                  {{ `数据来源：全国${this.params.positionName}近一年` }}
                </span>
                <span class="light-blue--text text--darken-4">
                  {{ zpData.sampleCount }}
                </span>
                <span>
                  份样本数据
                </span>
              </div>
            </div>
            <div class="title-card-text-class text-end">
              <div>
                <v-btn color="primary" text @click="cityDialog = true">
                  {{ this.params.cityName }}
                </v-btn>
              </div>

              <div>
                {{ month.month }}平均月薪
                <span>
                   <v-icon v-if="month.grow" class="red--text">
                      trending_up
                   </v-icon>

                  <v-icon v-else class="green--text">
                      trending_down
                  </v-icon>
                </span>
                <span class="text-button">
                    {{ month.percent }}%
                </span>
              </div>
              <div>
                <span>
                  ￥{{ month.monthAveSalary | formatMoney }}
                </span>
              </div>
            </div>
          </div>
        </v-card-title>
      </v-card>
    </div>

    <!--  统计数据  -->
    <div class="card-item-class">
      <div>
        <v-container fluid>
          <v-row justify="space-between">
            <v-col cols="12" xs="12" sm="12" lg="6">
              <v-card class="card-item-content">
                <v-card-title>
                  年薪收入分位值
                </v-card-title>
                <v-divider></v-divider>
                <div class="echarts-class" :style="{'height':`${size.height}px`}">
                  <v-points ref="points"></v-points>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" xs="12" sm="12" lg="6">

              <v-card class="card-item-content">
                <v-card-title>
                  年薪收入区间分布
                </v-card-title>
                <v-divider></v-divider>
                <div class="echarts-class" :style="{'height':`${size.height}px`}">
                  <v-distributed ref="distributed"></v-distributed>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>

    </div>

    <div class="card-item-class">
      <v-container fluid>
        <v-row>
          <v-col cols="12" xs="12" sm="12" lg="6">
            <v-card class="card-item-content">
              <v-card-title>
                工作年限薪酬分布
              </v-card-title>
              <v-divider></v-divider>
              <div class="echarts-class" :style="{'height':`${size.height}px`}">
                <v-work-exp ref="workExp"></v-work-exp>
              </div>
            </v-card>

          </v-col>
          <v-col cols="12" sm="12" lg="6">
            <v-card class="card-item-content">
              <v-card-title>
                任职年龄分布
              </v-card-title>
              <v-divider></v-divider>
              <div class="echarts-class" :style="{'height':`${size.height}px`}">
                <v-age ref="age"></v-age>
              </div>
            </v-card>

          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="card-item-class">
      <v-card class="card-item-content">
        <v-card-title>
          平均月薪变化
        </v-card-title>

        <v-divider></v-divider>

        <div class="echarts-class" :style="{'height':`${size.height}px`}">
          <v-month ref="month"></v-month>
        </div>

      </v-card>
    </div>

    <div class="card-item-class">
      <v-card class="card-item-content">
        <v-card-title>
           月薪地图总览
        </v-card-title>

        <v-divider></v-divider>

        <div class="echarts-class" :style="{'height':`${isModel ? size.height : size.height + 200}px`}">
          <v-map ref="map"></v-map>
        </div>

      </v-card>
    </div>

    <!--弹窗  -->
    <div>
      <v-dialog
          v-model="cityDialog"
          width="600px"
          scrollable
      >
        <v-card>
          <v-card-title>
            选择地区
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-city :data="cityList" @change="cityChange"></v-city>
          </v-card-text>
        </v-card>

      </v-dialog>

    </div>

    <div>
      <v-dialog
          v-model="positionDialog"
          width="600px"
          scrollable
      >
        <v-card>
          <v-card-title>
            选择职业
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-position :data="positionConfigList" @change="positionChange"></v-position>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <!--消息-->

    <v-message :content="msg"></v-message>

  </div>
</template>

<script>
import mapEcharts from '@/components/salary/info/mapEcharts'
import points from '@/components/salary/info/points'
import distributed from '@/components/salary/info/distributed'
import age from '@/components/salary/info/age'
import workExp from '@/components/salary/info/workExp'
import month from '@/components/salary/info/month'
import {newCity, positionConfigList, statistics} from '@/api/resources/salary'
import {Encrypt} from "@/utils/Aes";
import city from '@/components/salary/city'
import position from '@/components/salary/position'
import message from "@/components/Message";
import {mapGetters, mapMutations} from "vuex";

export default {
  name: "info",
  components: {
    'v-map': mapEcharts,
    'v-points': points,
    'v-distributed': distributed,
    'v-age': age,
    'v-work-exp': workExp,
    'v-month': month,
    'v-city': city,
    'v-position': position,
    'v-message': message
  },
  data: () => ({
    positionConfigList: [],
    cityList: [],
    cityValue: undefined,
    positionValue: undefined,
    cityDialog: false,
    positionDialog: false,
    // infoDialog: false,
    msg: {
      snackbar: false,
      text: '',
    },
    params: {},
    size: {
      height: undefined,
      width: undefined,
    },
    month: {},
    zpData: {},
  }),
  computed: {
    isModel() {
      return this.$vuetify.breakpoint.name === 'xs';
    },
    ...mapGetters(['getDarker']),
  },
  mounted() {
    this.params = {
      ...this.$route.query
    }
    this.size = {
      height: this.isModel ? this.$vuetify.breakpoint.height - 300 : this.$vuetify.breakpoint.height / 2,
      width: this.$vuetify.breakpoint.width
    }
    this.onResize()
    window.addEventListener('resize', this.onResize, {passive: true})

    this.submit()

    this.init()

  },
  methods: {
    ...mapMutations(['setLoading', 'clearLoading']),
    init() {
      Promise.all([this._newCity(), this._positionConfigList()])
          .then(([newCity, positionConfigList]) => {

            this.cityList = newCity.data

            this.positionConfigList = positionConfigList.data
          })
    },

    submit() {
      this.setLoading();
      let _params = Encrypt(JSON.stringify(this.params));
      statistics({encryptStr: _params}).then(res => {
        if (res.data.success) {
          this.zpData = res.data.data

          let {salaryByMonth} = this.zpData

          this.month = salaryByMonth[salaryByMonth.length - 1]

          this.echartsInit()
        }
      }).finally(() => {
        this.clearLoading()
      })
    },

    _newCity() {
      return new Promise((resolve, reject) => {
        newCity().then(res => {
          resolve(res.data)
        }).catch(e => {
          reject(e);
        })
      })
    },
    _positionConfigList() {
      return new Promise((resolve, reject) => {
        positionConfigList().then(res => {
          resolve(res.data)
        }).catch(e => {
          reject(e);
        })
      })
    },


    echartsInit() {
      this.$nextTick(() => {
        let {
          salaryByPoints,
          salaryByCity,
          salaryByWorkExp,
          salaryByMonth,
          salaryByDistributed,
          salaryByAge
        } = this.zpData

        this.$refs.points.init(salaryByPoints)

        this.$refs.map.init(salaryByCity)

        this.$refs.workExp.init(salaryByWorkExp)

        this.$refs.month.init(salaryByMonth)

        this.$refs.distributed.init(salaryByDistributed)

        this.$refs.age.init(salaryByAge)
      })

    },

    onResize() {
      this.$nextTick(() => {

        this.$refs.points.resize()

        this.$refs.map.resize()

        this.$refs.workExp.resize()

        this.$refs.month.resize()

        this.$refs.distributed.resize()

        this.$refs.age.resize()
      })
    },

    cityChange(code, name) {
      // this.cityValue = {
      //   code, name
      // }

      this.params.cityValue = code
      this.params.cityName = name

      this.cityDialog = false
      this.submit()
    },
    positionChange(code, name) {
      // this.positionValue = {
      //   code, name
      // }
      this.params.positionId = code;
      this.params.positionName = name;

      this.positionDialog = false
      this.submit()
    },

  },
  beforeDestroy() {
    if (typeof window === 'undefined') return

    window.removeEventListener('resize', this.onResize)
  },
}
</script>

<style scoped>
.main-class {
  height: 100%;
  width: 100%;
}

.card-title-class {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 100%;
}

.title-card-text-class {
  width: 50%;
}

.card-item-content {
  padding: 20px;
}

.echarts-class {
  padding: 10px;
}

/*.input-class {*/
/*  display: flex;*/
/*  align-content: center;*/
/*  flex-flow: row wrap;*/
/*  height: 100%;*/
/*}*/

/*.card-text-class {*/
/*  display: flex;*/
/*  align-content: center;*/
/*  flex-flow: row wrap;*/
/*  justify-content: center;*/
/*  width: 100%;*/
/*  height: 100%;*/
/*}*/

/*.card-text-item-class {*/
/*  width: 30%;*/
/*  height: 100%;*/
/*}*/

</style>
